import * as THREE from 'three';
import {getRadians} from '../../../../utils';

function addShadowPlane(scene) {
    const size = 200;
    const geometry = new THREE.PlaneGeometry(size, size);
    const material = new THREE.ShadowMaterial({opacity: 0.2});

    const shadowPlane = new THREE.Mesh(
        geometry,
        material
    );

    shadowPlane.receiveShadow = true;
    shadowPlane.rotation.x = getRadians(-90);
    shadowPlane.position.y = -0.1;

    scene.add(shadowPlane);
}

export default addShadowPlane;
